export function getErrorMessage(error) {
  const data = error?.response?.data

  if (typeof data?.message === 'string') {
    return data.message
  }

  return ''
}

function isMissingServiceError(error) {
  const services = error?.response?.data?.errors?.services

  return Array.isArray(services) && services.length > 0
}

export function isResourceAccessDenied(error) {
  const status = error?.response?.status
  const message = getErrorMessage(error).toLowerCase()

  if (status === 401) {
    return true
  }

  if (status === 403) {
    if (message.includes('no tiene permisos suficiente') ||
      message.includes('no pertenece')) {
      return true
    }

    if (isMissingServiceError(error)) {
      return true
    }

    // Blob responses hide JSON message; skipGlobal403Logout marks resource-scoped requests.
    if (error.config?.skipGlobal403Logout) {
      return true
    }
  }

  return false
}
